import ENV from "config/Env";
import { useTypedMutation } from "hooks";
import { ApiInstance } from "utils/Api";

export const useKeyLockerBoxAdminPinMutation = () =>
  useTypedMutation<number, { pin: string }>({
    mutationFn: async keylocker_box_id => (await ApiInstance.post("/dashboard/admin/pin", { keylocker_box_id }, ENV.keylockerBaseURL)).data,
    onSuccess: () => null
  });
